export default __webpack_public_path__ + "static/media/cleanproNewUserBanner.524f604f.jpg";